





































































































































































































// TODO: Enable lint.
/* eslint-disable */
import { computed, defineComponent, onMounted, reactive, ref, SetupContext } from '@vue/composition-api';
import API from '@aws-amplify/api';
import Auth from '@aws-amplify/auth';
import axios from 'axios';
import Fuse from 'fuse.js';
import moment from 'moment';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

import NavHeader from '@/components/NavHeader.vue';
import Footer from '@/components/Footer.vue';

type Image = {
  id: string,
  name: string,
  url: string,
};

type Concept = {
	id: string,
	project_id: string,
	cp_template_id: string,
	name?: string,
	title?: string,
	description?: string,
  image_vertical_size?: number,
	topbox?: number,
	sum_of_top2box?: number,
	created_at: string,
	updated_at: string,

  concept_image_id: string,
  cpcard_image_id: string,

  project_name: string,

  cpcard_image: Image,
};

type Project = {
  id: string,	
	organization_id: string,
	user_id: string,       
	name: string,         
	supplemental_memo: string,
	internal_memo: string,
  default_cp_template_id: string,
	is_archived: boolean,
	created_at: string,    
	updated_at: string,

  concepts: Concept[],
}

export default defineComponent({
  name: "ArchiveList",
  components: {
    Loading,
    NavHeader,
    Footer,
  },
  head: {
    link: [
      { rel: 'stylesheet', type: 'text/css', href: '/css/style.css' },
      { rel: 'stylesheet', type: 'text/css', href: '/css/login/archive.css' }
    ],
    script: [
      { src: "https://ajax.googleapis.com/ajax/libs/jquery/1.7/jquery.min.js" },
      { src: "/js/toggle_contents.js" },
      { src: "/js/archive.js" }
    ]
  },
  filters: {
    moment: function (date: string) {
      moment.locale('ja')
      return moment(date).format('YYYY/MM/DD')
    },
    shorten: function (id: string) {
      if (id === null ) return '';
      if (id.length > 7)
        return id.substring(0, 7).toUpperCase();
      else
        return id;
    }
  },

  setup(_, context: SetupContext) {
    const searchModes = [
      { mode: 'topbox', name: 'TOPBOXの値' },
      { mode: 'top2box', name: 'TOP2BOX計の値' }
    ];

    const state = reactive({
      loading: false,
      activeID: '',
      allProjects: [] as Project[],
      searchMode: '',
      upperLimit: '',
      lowerLimit: '',
    })

    const filter = ref('');
    const fuseOptions = {
      keys: ['name', 'supplemental_memo']
    };
    const pageSize = 10;
    const currentPage = ref(1);
    const pages = computed(() => {
      let projs = ((ps: Project[], fv: string) => {
        if (fv.trim() === '') {
          return ps;
        } else {
          const fuse = new Fuse(state.allProjects, fuseOptions);
          return fuse.search(filter.value).map(r => { return r.item });
        }
      })(state.allProjects, filter.value);

      projs = ((ps: Project[], searchMode, lowerLimit, upperLimit) => {
        if (searchMode !== '' && lowerLimit !== '' && upperLimit !== '') {
          const ll = parseFloat(lowerLimit);
          const ul = parseFloat(upperLimit);
          if (Number.isNaN(ll) || Number.isNaN(ul)) return [];

          switch (searchMode) {
            case 'topbox':
              return projs.filter(p => {
                return p.concepts.filter(c => {
                  return c.topbox && ll <= c.topbox && c.topbox <= ul;
                }).length > 0;
              });
            case 'top2box':
              return projs.filter(p => {
                return p.concepts.filter(c => {
                  return c.sum_of_top2box && ll <= c.sum_of_top2box && c.sum_of_top2box <= ul;
                }).length > 0;
              });
            default:
              console.log("Unreachable code!!");
              console.log("SearchMode: " + searchMode);
              return projs;
          }
        } else {
          return projs;
        }
      })(projs, state.searchMode, state.lowerLimit, state.upperLimit);

      return projs.reduce(
        (pgs, _, i) => (i % pageSize ? pgs : [...pgs, projs.slice(i, i + pageSize)]), 
        [] as Project[][]
      );
    });
    const projects = computed(() => {
      return pages.value[currentPage.value - 1];
    });
    const fromNum = computed(() => {
      if (state.allProjects.length === 0) {
        return state.allProjects.length;
      } else {
        return (currentPage.value - 1) * pageSize + 1;
      }
    });
    const toNum = computed(() => {
      const to = (currentPage.value - 1) * pageSize + pageSize
      if (to > state.allProjects.length) {
        return state.allProjects.length;
      } else {
        return to;
      }
    });

    async function loadImage(data: Blob): Promise<string> {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e: Event) => {
          resolve(reader.result as string);
        };
        reader.readAsDataURL(data);
      });
    }

    async function load() {
      state.loading = true;

      const options = {
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}`
        },
        queryStringParameters: {
          mode: 'archive',
          pid: '',
          cid: '',
        }
      }

      const response = await API.get('dev', '/projects', options);
      console.log(response);
      state.allProjects = response.data;
      state.allProjects = await Promise.all(state.allProjects.map(async (p: Project) => {
        if (p.concepts === null) {
          p.concepts = [] as Concept[];
        }
        p.concepts = await Promise.all(p.concepts.map(async (cp: Concept) => {
          if (cp.cpcard_image_id) {
            options.queryStringParameters.pid = cp.project_id;
            options.queryStringParameters.cid = cp.id;

            const cpcard = await API.get('dev', '/images/cpcards/' + cp.cpcard_image_id, options);
            cp.cpcard_image = cpcard.data;

            const image = await axios.get(cpcard.data.url, { responseType: 'blob' });
            cp.cpcard_image.url = await loadImage(image.data);
          } else {
            cp.cpcard_image = { id: '', name: '', url: '/images/archive_img.png'};
          }
          return cp;
        }));

        return p;
      })).catch(err => {
        console.log(err);
        return [] as Project[];
      }).finally(() => {
        state.loading = false;
      });
      console.log(state.allProjects)
    }
    load();

    onMounted(() => {
      console.log('ProjectView onMounted!!');
    });

    function activate(id: string) {
      if (state.activeID === id) {
        state.activeID = '';
      } else {
        state.activeID = id;
      }
    }

    function resetCriteria() {
      filter.value = '';
      state.searchMode = '';
      state.upperLimit = '';
      state.lowerLimit = '';
    }

    return {
      state,
      activate,
      resetCriteria,

      searchModes,

      filter,
      pageSize,
      pages,
      currentPage,
      projects,
      fromNum,
      toNum,
    };
  }

});
